import Box from "./Box";
import Grid from "./Grid";
import NumberCircle from "./NumberCircle";
import PropTypes from "prop-types";
import React from "react";

function NumberedItem({ number, children, itemBoxProps, ...props }) {
  return (
    <Grid
      gridColumnGap={60}
      gridRowGap={30}
      gridTemplateColumns={["1fr", "auto 1fr", null, null]}
      {...props}
    >
      <NumberCircle>{number}</NumberCircle>
      <Box {...itemBoxProps}>{children}</Box>
    </Grid>
  );
}

NumberedItem.propTypes = {
  number: PropTypes.number.isRequired,
  itemBoxProps: PropTypes.object,
};

NumberedItem.defaultProps = {
  itemBoxProps: {},
};

export default NumberedItem;
